import type { SyncStatus } from "@brandwall/contracts";
import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router";
import { useMe } from "../App";
import { api } from "../api";
import { Steps } from "../components/Steps";

export function Collecting() {
  const { ws } = useParams();
  const me = useMe();
  const workspace = me.data?.workspaces.find((w) => w.id === ws);
  const sync = useQuery({
    queryKey: ["sync", ws],
    queryFn: () => api<SyncStatus>(`/v1/w/${ws}/sync`),
    refetchInterval: (q) =>
      q.state.data && !q.state.data.running && q.state.data.finishedAt ? false : 1500,
  });
  const s = sync.data;
  const count = s ? Math.max(s.totalPosts, s.found) : 0;
  const done = Boolean(s && !s.running && s.finishedAt);
  return (
    <div className="onb">
      <div className="box">
        <img className="logo" src="/logo.svg" alt="Brandwall" />
        <Steps at={done ? 4 : 3} />
        <div className="card stack" style={{ textAlign: "center" }}>
          <div>
            <h1>Collecting your posts</h1>
            <p className="muted">
              We're gathering your own posts and posts that tagged {workspace?.name ?? "you"} in the
              last 90 days. You can start reviewing them right away.
            </p>
          </div>
          <div aria-live="polite">
            <div className="big-count">{count}</div>
            <div className="muted">posts found{done ? "" : " so far"}</div>
          </div>
          {s?.error && <p className="error">{s.error}</p>}
          <Link className="btn block" to={`/w/${ws}/inbox`}>
            Go to your inbox
          </Link>
        </div>
      </div>
    </div>
  );
}
